
const app = {
  state: {
    transactionStatus:['Failure','success']
  },
  mutations: {

  },
  actions: {

  },
  getters: {
    transactionStatus:state=>state.transactionStatus
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js